export const stepNavigation: any[]=[
    {
        "Key": "step1",
        "Value": "fas fa-check",
        "isActive": true,
        "isStage": false,
        "Name": "lblYourDetails"
    },
    {
        "Key": "step2",
        "Value": "fas fa-question-circle",
        "isActive": false,
        "isStage": false,
        "Name": "lblConfirmedWork"
    },
    {
        "Key": "step3",
        "Value": "fas fa-user-shield",
        "isActive": false,
        "isStage": false,
        "Name": "lblCurrentOffer"
    },
    {
        "Key": "step4",
        "Value": "fas fa-tools",
        "isActive": false,
        "isStage": false,
        "Name": "lblTerms&Conditions"
    },
]